// docs: https://github.com/streamich/react-use/blob/master/docs/useMedia.md
// ref:  https://github.com/streamich/react-use/blob/master/src/useMedia.ts
import { useEffect, useState } from 'react';

/**
 * 画面幅の判定をする
 */
const useMedia = (query: string, defaultState = false) => {
  const [state, setState] = useState(
    typeof window === 'object'
      ? () => window.matchMedia(query).matches
      : defaultState
  );

  useEffect(() => {
    let mounted = true;
    const mql = window.matchMedia(query);
    const onChange = () => {
      if (!mounted) return;
      setState(!!mql.matches);
    };

    mql.addListener(onChange);
    setState(mql.matches);

    return () => {
      mounted = false;
      mql.removeListener(onChange);
    };
  }, [query]);

  return state;
};

export default useMedia;
